<template>
  <v-radio-group row dense :class="{
    'justify-center': true,
    'radio-group': true,
    'extra-dense': this.$store.getters.isMobile
  }" v-model="selectedDistrictType">
    <v-radio data-cy="type-select" dense v-for="n in districtTypes" :key="n.value" :value="n.value">
      <template v-slot:label>
        <div class="radio-label text-uppercase font-weight-bold">
          {{ n.label }}
        </div>
      </template>
    </v-radio>
  </v-radio-group>
</template>
<script>
import { EventBus } from "../../js/DataManagement/EventBus";

export default {
  name: "LegislativeTypeSelector",
  components: {},
  data: function () {
    return {
      districtTypes: [
        { label: "Congress", value: "cd" },
        { label: "State Lower House", value: "ad" },
        { label: "State Upper House", value: "sd" },
      ],
      selectedDistrictType: "",
    };
  },
  mounted: function () {
    const self = this;
    this.$nextTick(() => {
      self.selectedDistrictType = self.$store.getters.getActiveDistrictType;
    });
  },
  methods: {},
  watch: {
    selectedDistrictType: function (val) {
      this.$store.commit("setActiveDistrictType", val);
      this.$querystringManager.addQueryParam("districtType", val);
      this.$nextTick(() => {
        // either use the lnglat value in the store or selected querystringManager
        const selected = new URLSearchParams(window.location.search).get('selected');
        const selectedLngLat = selected?.split(",").map((l) => +l) ?? [];
        const lnglat = this.$store.getters.getSelectedLngLat.value || selectedLngLat;
        EventBus.$emit("select-from-type-switch", lnglat);
      });
    },
  },
  computed: {},
};
</script>
<style>
.radio-label {
  font-size: 0.75em;
}

.justify-center .v-input--radio-group__input {
  justify-content: center;
}

.radio-group {
  margin-bottom: -20px;
}

.extra-dense {
  margin-top: 0px;
}
</style>
